import { BezierEdge, BezierEdgeModel } from "@logicflow/core";
import {
  getShapeStyleFuction,
  getTextStyleFunction,
} from "../getShapeStyleUtil";

// 贝塞尔曲线
class Model extends BezierEdgeModel {
  constructor(data, graphModel) {
    super(data, graphModel);
    this.text.editable = false; // 禁止节点文本编辑
    this.strokeWidth = 1;
  }
  getTextStyle() {
    const style = super.getTextStyle();
    return getTextStyleFunction(style, this.properties);
  }

  getEdgeStyle() {
    const attributes = super.getEdgeStyle();
    const properties = this.properties;
    const style = getShapeStyleFuction(attributes, properties);
    style.strokeWidth = 1;
    if (properties.isHidden == "2") {
      style.stroke = "#000000";
    } else if (properties.isHidden == "1") {
      style.stroke = "none";
    }
    return { ...style, fill: "none" };
  }
}
export default {
  type: "pro-bezier",
  view: BezierEdge,
  model: Model,
};
